function importAll(r) {
  r.keys().forEach(r)
}
  
importAll(import.meta.webpackContext("../../../app/components", { recursive: true, regExp: /[_/]component\.js$/ }))
